<template>
    <div class="col-md-12">
        <form class="form-horizontal">
            <fieldset>
                <div class="col-md-6">
                    <forminput v-bind:controller="controller.name"></forminput>
                    <!--<addressEditor :address="controller.address" ></addressEditor>-->
                    <!--<addressGroupEditor></addressGroupEditor>-->
                </div>
            </fieldset>
        </form>
    </div>
</template>



<script>

    import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    //import datepicker from "./../../corecontrols/datepicker/datepicker.scp.html"
    //import formselect from "./../../corecontrols/formselect/formselect.scp.html"
    //import formtextarea from "./../../corecontrols/formtextarea/formtextarea.scp.html"
    //import formimageupload from "./../../corecontrols/formimageupload/formimageupload.scp.html"
    //import formimage from "./../../corecontrols/formimage/formimage.scp.html"

    import addressEditor from "./../../appcontrols/addressEditor/addressEditor.scp.html"
    import addressGroupEditor from "./../../appcontrols/addressEditor/addressGroupEditor.scp.html"


    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import { CarehomeDetailController } from './carehome-detail-controller.ts'

    export default {
        props: ['carehomeid'],
        data: function () {
            var controller = new CarehomeDetailController(new CarehomeDto())
            return {
                controller: controller
            }
        },
        mounted: function () {
            if (this.carehomeid) {
                var dal = new Dal();
                var carehomeid = this.carehomeid;
                var that = this;
                dal.GetCarehome(carehomeid).then(dto => {
                    that.controller = new CarehomeDetailController(dto)
                })

            }
        },
        methods: {
            createItem: function () {
                alert("Submit")
            },
            cancel: function() {
                alert("cancel")
            }
        },
        components: {
            forminput,
            addressEditor,
            addressGroupEditor
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-detail.scp.html?bd764348